import { useRef } from 'react';
import { ImageStyle, TextStyle, ViewStyle } from 'react-native';

import { Styles } from '../../types/styles';

import { checkForStyleChanges, parseStyles } from './index.utils';

import useTheme from '../useTheme';
import useBreakpoint from '../useBreakpoint';

const useStyle = <T extends ViewStyle | TextStyle | ImageStyle>(
  styles: Styles<T>,
) => {
  const theme = useTheme();
  const breakpoint = useBreakpoint();
  const cache = useRef({
    theme,
    styles,
    style: parseStyles<T>(styles, breakpoint, theme),
  });

  if (
    theme !== cache.current.theme ||
    checkForStyleChanges(styles, cache.current.styles)
  ) {
    cache.current = {
      theme,
      styles,
      style: parseStyles<T>(styles, breakpoint, theme),
    };
  }

  return cache.current.style;
};

export default useStyle;
